module.exports = __webpack_public_path__ + "img/img_22.bd72e9d1.jpg";